export default __webpack_public_path__ + "static/media/side_bottom.80374303.svg";